import * as CollectionMetadata from './CollectionMetadata';
export const fromGql = (collection, collectionDeserializer) => ({
    metadata: CollectionMetadata.fromGql(collection.metadata),
    collection: collectionDeserializer(collection.collection),
});
//# sourceMappingURL=GqlCollection.js.map